import Vue from 'vue';
var toString = Object.prototype.toString;
export var isFunction = function (arg) { return typeof arg === 'function'; };
export var isObject = function (arg) {
    return toString.call(arg) === '[object Object]';
};
export var warn = Vue.util.warn;
//# sourceMappingURL=utils.js.map